module.exports = __webpack_public_path__ + "static/globoplay-42818748462a2045b43bcd6b1d5892f7.png";